module.exports = __webpack_public_path__ + "media/assets/images/html_editor/redo-01fd8d9d69a8c0cf64d5d8bd5d85f8b4.svg";